import elementLocale from 'element-ui/lib/locale/lang/de';

export default {
  // Messages
  messages: {
    '{brand} ending in {last4}': '{brand} endet in {last4}',
    '{count} Pages Selected': 'keine Seite ausgewählt | 1 Seite ausgewählt | {count} Seiten ausgewählt',
    '{count} Pages': 'keine Seite | 1 Seite | {count} Seiten',
    '{user} published changes to {page} on {site}': '{user} Änderungen veröffentlichen von {page} auf {site}',
    '{user} saved a draft of {page} on {site}': '{user} Entwurf speichern von {page} auf {site}',
    '100%': '100%',
    '25%': '25%',
    '50%': '50%',
    '75%': '75%',
    'A file already exists at the specified location.': 'Es gibt bereits eine Datei an diesem Ort.',
    'Access Control List (ACL)': 'Zugriffskontrollliste (ACL)',
    'Access Key': 'Zugangscode',
    'Actions': 'Aktionen',
    'Add To Favorites': 'zu Favoriten hinzufügen',
    'Additional Text': 'zusätzlicher Text',
    'Admin': 'Admin',
    'Advanced': 'Fortgeschritten',
    'Align Center': 'zentriert aurichten',
    'Align Left': 'links ausrichten',
    'Align Right': 'rechts ausrichten',
    'Alignment': 'Anpassung',
    'All Images': 'Alle Bilder',
    'All Pages': 'Alle Seien',
    'Allow this user to change the settings for this account.': 'Erlaube diesem Benutzer die Einstellungen dieses Accounts zu ändern.',
    'Allow this user to create, delete, and update sites.': 'Ermöglichen Sie diesem Benutzer das Erstellen, Löschen und Aktualisieren von Websites.',
    'Allow this user to create, delete, and update users.': 'Ermöglichen Sie diesem Benutzer, Benutzer zu erstellen, zu löschen und zu aktualisieren.',
    'Allow this user to view invoices and manage payment info.': 'Erlaube diesem Benutzer Rechnungen und Zahlungsinformationen zu verwalten.',
    'Allow users to delete pages on this site.': 'Benutzern erlauben, Seiten auf dieser Website zu löschen.',
    'Allow users to duplicate pages on this site.': 'Benutzern erlauben, Seiten auf dieser Website zu duplizieren.',
    'Alternative text for users who can\'t see images.': 'Alternativer Text für Benutzer, welche Bilder nicht sehen können.',
    'Amount': 'Betrag',
    'An account has been created for you to manage your website. Please follow the link below to confirm your account.': 'Es wurde ein Konto für die Verwaltung Ihrer Website erstellt. Bitte folgen Sie dem Link unten, um Ihr Konto zu bestätigen.',
    'An error occurred. Please try your request again later.': 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es später noch einmal.',
    'An invitation will be sent to this email address when the user is created.': 'Eine Einladung wird an diese E-Mail Adresse gesendet, sobald der Benutzer erstellt ist.',
    'Analytics': 'Analytics',
    'Anchor': 'Anker',
    'API Access': 'API-Zugriff',
    'App Name': 'App Name',
    'Apply': 'anwenden',
    'Are you sure you want to delete {count} files?': 'Hier gibt es nichts zu löschen! | Sind Sie sicher, dass Sie dieses Dokument löschen wollen? | Sind Sie sicher, dass Sie {count} Dokumente löschen wollen?',
    'Are you sure you want to do this?': 'Sind Sie sicher, dass Sie dies tun möchten?',
    'Authentication': 'Authentifizierung',
    'Average Time On Site': 'Durchschnittszeit auf der Website',
    'Back To Site': 'Zurück zur Website',
    'Back': 'Zurück',
    'Background': 'Hintergrund',
    'Best Fit': 'passt am besten',
    'Billing': 'Rechnungen',
    'Bio': 'Bio',
    'Blockquote': 'Blockquote',
    'Blocks cannot contain ID attributes.': 'Blocks können keine ID Eigenschaften enthalten.',
    'Blocks': 'Blocks',
    'Bold': 'Fett',
    'Bounce Rate': 'Schwankungsrate',
    'Branding': 'Branding',
    'Browse': 'Browse',
    'Browsers': 'Browsers',
    'Bucket': 'Abfall',
    'Bug Report': 'Fehlermeldung',
    'Bulleted List': 'Aufzählungszeichen',
    'Can this question help other users?': 'Kann diese Fragen anderen Benutzern helfen?',
    'Cancel': 'Abbrechen',
    'Caption': 'Überschrift',
    'Cell': 'Zelle',
    'Change Password': 'Passwort ändern',
    'Change Profile Picture': 'Profilbild ändern',
    'Changing this will cause all active users to be logged out immediately. You are responsible for informing users of the new domain.': 'Diese Änderung hat zur Folge, dass alle aktiven Benutzer sofort ausgeloggt werden. Sie sind verantwortlich, die Benutzer darüber zu informieren.',
    'Choose Image': 'Bild auswählen',
    'Cities': 'Städte',
    'Classification': 'Einstufung',
    'Cleanup Code': 'Cleanup Code',
    'Client': 'Kunde',
    'Code Block': 'Code Block',
    'Code': 'Code',
    'Color': 'Frabe',
    'Column': 'Spalte',
    'Commercial': 'Kommerziellen',
    'Confirm My Account': 'Bestätige mein Konto',
    'Congratulations! Two-factor authentication has been enabled for your account.': 'Herzliche Glückwünsche! Die Zwei-Faktor-Authentifizierung wurde für Ihr Konto aktiviert.',
    'Connect your Google Analytics account to enable the analytics dashboard for selected sites.': 'Verbinden Sie ihren Google Analytics Account, um das Analytics Dashboard für ausgewählte Seiten freizugeben.',
    'Connecting...': 'Verbinden…',
    'Connection successful!': 'Verbindung erfolgreich!',
    'Content': 'Inhalt',
    'Continents': 'Kontinent',
    'Continue Editing': 'Bearbeitung fortsetzen',
    'Continue': 'Fortfahren',
    'Copy and paste the video\'s URL or embed code here.': 'Die URL oder den eingebunden Code des Videos kopieren und hier einfügen.',
    'Countries': 'Länder',
    'Cover': 'Cover',
    'Create Block': 'Block erstellen',
    'Create Folder': 'Ordner erstellen',
    'Create Page': 'Seite erstellen',
    'Create Site': 'Website erstellen',
    'Create Template': 'Vorlage erstellen',
    'Create User': 'Benutzer erstellen',
    'Current Password': 'aktuelles Passwort',
    'Customize Invoices': 'kundenspezifische Rechnungen',
    'Dark Logo': 'dunkles Logo',
    'Dashboard': 'Dashboard',
    'Date': 'Datum',
    'Decrease Indent': ' Einzug verringern',
    'Delete Anchor': 'Anker löschen',
    'Delete Block': 'Block löschen',
    'Delete Code Block': 'Code Block löschen',
    'Delete Column': 'Spalte löschen',
    'Delete Gallery': 'Galerie löschen',
    'Delete Image': 'Bild löschen',
    'Delete My Account': 'Meinen Account löschen',
    'Delete Row': 'Reihe löschen',
    'Delete This Site': 'Diese Website löschen',
    'Delete This User': 'Diesen Benutzer löschen',
    'Delete Video': 'Video löschen',
    'Delete': 'Löschen',
    'Delete Pages': 'Seiten löschen',
    'Demo Site': 'Demo Website',
    'Depth of Visit': 'Tiefe des Besuches',
    'Description': 'Beschreibung',
    'Devices': 'Geräte',
    'Did we make a mistake? Let us know!': 'Haben wir einen Fehler gemacht? Bitte melden Sie uns dies!',
    'Disable API Access': 'API deaktivieren',
    'Disable Line Wrapping': 'Line Wrapping deaktivieren',
    'Disable lockdown to make changes to this site.': 'Abschaltung deaktivieren, um Änderungen auf dieser Website durchzuführen.',
    'Disable Two-factor Authentication': 'Deaktivieren Sie die Zwei-Faktor-Authentifizierung',
    'Disable': 'Deaktivieren',
    'Documentation': 'Dokumentation',
    'Domain': 'Domain',
    'Done': 'Fertig',
    'Draft': 'Entwurf',
    'Drafts & Revisions': 'Entwürfe & Überarbeitungen',
    'Drag and drop an HTML file or copy and paste the full source of your block.': 'Eine HTML-Datei ziehen und ablegen oder kopieren und einfügen der ganzen Quelle des Blockes.',
    'Drag and drop an HTML file or copy and paste the full source of your page template.': 'Eine HTML-Datei ziehen und ablegen oder kopieren und einfügen der ganzen Quelle Ihrer Seitenvorlage.',
    'Duplicate ID': 'ID duplizieren',
    'Duplicate': 'Duplizieren',
    'Duplicate Pages': 'Doppelte Seiten',
    'Edit Block': 'Block bearbeiten',
    'Edit Metadata': 'Metadaten bearbeiten',
    'Edit Profile': 'Profil bearbeiten',
    'Edit Site': 'Website bearbeiten',
    'Edit Source': 'Quelle bearbeiten',
    'Edit Template': 'Vorlage bearbeiten',
    'Edit User': 'Benutzer bearbeiten',
    'Edit': 'Bearbeiten',
    'Educational': 'Lehrreich',
    'Email': 'E-Mail',
    'Embed Code': 'Eingebundener Code',
    'Enable access to programmatically manage sites, users, and more.': 'Aktivieren Sie den Zugriff zum programmgesteuerten Verwalten von Websites, Benutzern und mehr.',
    'Enable access to the CMS from a white-label domain.': 'Zugriffscode für CMS von einem white-lable Bereich aktivieren.',
    'Enable API Access': 'API aktivieren',
    'Enable Change Notifications': 'Benachrichtigung bei Änderungen aktivieren',
    'Enable Line Wrapping': 'Line Wrapping aktivieren',
    'Enable Lockdown': 'Ausschaltung aktivieren',
    'Enable Pages': 'Seiten aktivieren',
    'Enable Two-factor Authentication': 'Aktivieren Sie die Zwei-Faktor-Authentifizierung',
    'Enable': 'Aktivieren',
    'End Date': 'Enddatum',
    'Enter a brief description of this block.': 'Fügen Sie eine kurze Beschreibung dieses Blockes ein.',
    'Enter a brief description of this template.': 'Fügen Sie eine kurze Beschreibung dieser Vorlage ein.',
    'Enter a caption for the selected photo.': 'Fügen Sie eine Überschirft des ausgewählten Bildes ein .',
    'Enter a name for the new folder.': 'Name des neuen Ordners eingeben.',
    'Enter a name for your website.': 'Name der neuen Website eingeben.',
    'Enter the code generated by your app': 'Geben Sie den von Ihrer App generierten Code ein',
    'Enter your website\'s URL.': 'URL der website eingeben.',
    'Error': 'Fehler',
    'Exit Pages': 'Seite verlassen',
    'Failed to locate content region.': 'Konnte gesuchte Inhaltsregion nicht finden.',
    'Favicon': 'Favicon',
    'Favorites': 'Favoriten',
    'Feature Request': 'Eigenschaft Anfrage',
    'File Extension': 'Datei erweitern',
    'Filename': 'Dateiname',
    'Files cannot be recovered once they are deleted.': 'Dateien können nach dem Löschen nicht wieder hergestellt werden.',
    'Files cannot be uploaded here.': 'Dateien können hier nicht hochgeladen werden.',
    'Files': 'Datei',
    'Finished With Errors': 'Beendet mit Fehler',
    'Finished': 'Beendet',
    'Folder': 'Ordner',
    'Forgot your password?': 'Passwort vergessen?',
    'Format': 'Format',
    'Gallery': 'Galerie',
    'General Support': 'Allgemeine Hilfe',
    'General': 'Allgemein',
    'Get a helpful response in less than 24 hours, even on weekends and holidays.': 'Sie erhalten eine hilfreiche Antwort in weniger als 24h, auch an Wochenenden oder während den Ferien.',
    'Give this user administrative privileges.': 'Geben Sie diesem Benutzer Administratorrechte.',
    'Give your clients a custom solution with your company\'s branding. Clients will see your business, your logo, and your custom domain.': 'Geben Sie ihren Kunden eine kundenspezifische Lösung mit ihrer Firmas Marke. Kunden werden Ihr Geschäft, Ihr Logo und ihre kundenspezifischen Bereiche sehen.',
    'Go to the settings page to enable this feature.': 'Gehen Sie auf Einstellungen, um diese Möglichkeiten zu aktivieren.',
    'Heading {num}': 'Titel {num}',
    'Highlight': 'Hervorheben',
    'Home Folder': 'Home Ordner',
    'Homepage': 'Homepage',
    'Host': 'Host',
    'I have stored my recovery code in a secure place': 'Ich habe meinen Wiederherstellungscode an einem sicheren Ort gespeichert',
    'If set, clients will be sent to this URL instead of the standard support page.': 'Wenn ausgewählt, werden Kunden zu dieser URL geleitet anstatt auf die Standardseite für Hilfe.',
    'If so, consider posting it to the {forum} instead.': 'Denken Sie darüber nach, es stattdessen im {forum} zu posten.',
    'If you didn\'t request this, you can safely ignore this message.': 'Wenn Sie dies nicht angefordert haben, können Sie diese Nachricht ignorieren.',
    'If your bucket has ACLs enabled, enable this option to give "public-read" permissions to uploaded files.': 'Wenn in Ihrem Bucket ACLs aktiviert sind, aktivieren Sie diese Option, um den hochgeladenen Dateien „public-read“ zu erteilen.',
    'If your website doesn\'t use HTTPS, stylesheets and other mixed content will not load in the editor. Please consider securing your website with an SSL certificate.': 'Wenn Ihre Website nicht HTTPS benutzt, werden stylesheets und andere vermischte Inhalte nicht im Editor laden. Bitte sichern Sie ihre Website mit einem SSL Zertifikat ab.',
    'Image': 'Bild',
    'Increase Indent': 'Einzug vergrössern',
    'Insert Anchor': 'Anker einfügen',
    'Insert Block': 'Block einfügen',
    'Insert Code Block': 'Code Block einfügen',
    'Insert Column After': 'Spalte nach einfügen',
    'Insert Column Before': 'Spalte vor einfügen',
    'Insert Gallery': 'Gallerie einfügen',
    'Insert Image': 'Bild einfügen',
    'Insert Link': 'Link einfügen',
    'Insert Row After': 'Reihe nach einfügen',
    'Insert Row Before': 'Reihe vor einfügen',
    'Insert Table': 'Tabelle einfügen',
    'Insert Video': 'Video einfügen',
    'Insert': 'Einfügen',
    'Invoice': 'Rechnung',
    'Italic': 'Kursiv',
    'Keyboard Shortcuts': 'Tastatur Kurzbefehle',
    'Keywords': 'Schlüsselwörter',
    'Landing Pages': 'Landing Pages',
    'Landscape': 'Landscape',
    'Language': 'Sprache',
    'Language[computer]': 'Sprache',
    'Languages': 'Sprachen',
    'Last {days} days': 'Letzte {days} Tage',
    'Last seen {date}': 'Zuletzt gesehen {date}',
    'Last year': 'Letztes Jahr',
    'Launch {appName}': 'Starten Sie {appName}',
    'Length of Visit': 'Dauer des Besuches',
    'Light Logo': 'Light Logo',
    'Link': 'Link',
    'Links to this page will stop working. You should only change the filename if you\'re sure nothing is linking to this page.': 'Links zu dieser Seite werden nicht mehr funktionieren. Sie sollten den Dateinamen nur ändern, wenn Sie sicher sind, dass nichts auf diese Seite verlinkt ist.',
    'Lists': 'Listen',
    'Load More': 'Mehr laden',
    'Loading...': 'Laden…',
    'Login': 'Anmelden',
    'Logo': 'Logo',
    'Logos': 'Logos',
    'Logout': 'Abmelden',
    'Lost your device?': 'Hast du dein Gerät verloren?',
    'Main': 'Haupt',
    'Make Administrator': 'Mache Administrator',
    'Manage Billing': 'Rechnungen verwalten',
    'Manage Blocks': 'Blocks verwalten',
    'Manage Files': 'Dateien verwalten',
    'Manage Pages': 'Seiten verwalten',
    'Manage Settings': 'Einstellungen verwalten',
    'Manage Sites': 'Website verwalten',
    'Manage Templates': 'Vorlagen verwalten',
    'Manage Users': 'Benutzer verwalten',
    'Merge Cells': 'Zellen zusammenfügen',
    'Metadata': 'Metadata',
    'Missing ID': 'ID fehlend',
    'Mobile Devices': 'Mobile Devices',
    'Move Down': 'nach unten bewegen',
    'Move Up': 'nach oben bewegen',
    'My Account': 'Mein Account',
    'Name': 'Name',
    'Need something else to appear on your invoice?': 'Benötigen Sie etwas anderes, das in Ihrem Rechnungsbetrag erscheinen soll?',
    'Never logged in': 'Nie angemeldet',
    'New Block': 'Neuer Block',
    'New Folder': 'Neuer Ordner',
    'New Page': 'Neue Seite',
    'New Password': 'Neues Passwort',
    'New Site': 'Neue Website',
    'New Template': 'Neue Vorlage',
    'New User': 'Neuer Benutzer',
    'New Visits': 'Neue Besuche',
    'No Blocks': 'keine Blocks',
    'No Files': 'keine Dateien',
    'No Images': 'keine Bilder',
    'No Pages': 'keine Seiten',
    'No Recent Activity': 'keine kürzliche Aktivität',
    'No Results': 'keine Resultate',
    'No Revisions': 'keine Überarbeitungen',
    'No Sites': 'keine Websites',
    'No Templates': 'keine Vorlagen',
    'Non-profit': 'Gemeinnützig',
    'None': 'keine',
    'Not Found': 'nicht gefunden',
    'Now that you\'re connected, let\'s enable some pages!': 'Jetzt, da Sie verbunden sind, lassen Sie uns einige Seiten aktivieren!',
    'Now that you\'ve confirmed your account, you can manage your website any time using the link below.': 'Nachdem Sie Ihr Konto bestätigt haben, können Sie Ihre Website jederzeit über den folgenden Link verwalten.',
    'Numbered List': 'Nummerierte Liste',
    'Once your account is deleted, it cannot be recovered!': 'Wenn Ihr Account einmal gelöscht ist, kann er nicht wieder hergestellt werden!',
    'Open in a New Window': 'In einem neuen Fenster öffnen',
    'Open Revision': 'Überarbeitungen öffnen',
    'Operating Systems': 'Systeme in Betrieb',
    'Organization': 'Organisation',
    'Orientation': 'Orientierung',
    'Out of Service': 'Nicht in Betrieb',
    'Overview': 'Übersicht',
    'Owner': 'Besitzer',
    'Pages Per Visit': 'Seiten pro Besuch',
    'Pages': 'Seite',
    'Pageviews': 'Seitenansicht',
    'Paragraph': 'Paragraph',
    'Password': 'Passwort',
    'Passwords must be at least eight characters long.': 'Das Passwort muss mindestens 8 Zeichen lang sein.',
    'Payment History': 'Rechnungsverlauf',
    'Payment Source': 'Zahlungsquelle',
    'Permissions': 'Genehmigungen',
    'Personal Access Token': 'Persönliches Zugriffstoken',
    'Personal': 'Persönlich',
    'Photo of {name}': 'Foto von {name}',
    'Pin to Top': 'Pin to Top',
    'Please check your email for further instructions.': 'Bitte prüfen Sie Ihre E-Mail für weitere Instruktionen.',
    'Please choose a password for your new account.': 'Bitte wählen Sie ein Passwort für Ihren neuen Account.',
    'Please contact your administrator for details.': 'Bitte kontaktieren Sie Ihren Administrator für Details.',
    'Please correct the highlighted errors.': 'Bitte korrigieren Sie die hervorgehobenen Fehler.',
    'Please enter the recovery code you were given when you enabled two-factor authentication.': 'Bitte geben Sie den Wiederherstellungscode ein, den Sie erhalten haben, als Sie die Zwei-Faktor-Authentifizierung aktiviert haben.',
    'Please enter your password to continue.': 'Bitte geben Sie Ihr Passwort ein um fortzufahren.',
    'Please open your authentication app and enter the two-factor authentication code here.': 'Bitte öffnen Sie Ihre Authentifizierungs-App und geben Sie hier den Zwei-Faktor-Authentifizierungscode ein.',
    'Please provide details about the issue.': 'Bitte geben Sie Details zum Problem an.',
    'Please review the {guidelines}. Non-commercial websites are verified to prevent abuse.': 'Bitte lesen Sie die {guidelines}. Nicht-kommerzielle Websites werden überprüft, um Missbrauch zu verhindern.',
    'Please scan this code with your authentication app. If you don\'t have one, try one of these.': 'Bitte scannen Sie diesen Code mit Ihrer Authentifizierungs-App. Wenn Sie noch keine haben, probieren Sie eine davon aus.',
    'Please store this recovery code in a secure place such as a password manager. If you lose your device, you will need it to access your account.': 'Bitte speichern Sie diesen Wiederherstellungscode an einem sicheren Ort, z. B. in einem Passwort-Manager. Wenn Sie Ihr Gerät verlieren, benötigen Sie es, um auf Ihr Konto zugreifen zu können.',
    'Please upgrade your account to unlock this feature.': 'Bitte aktualisieren Sie Ihren Account, um diese Eigenschaften freizuschalten.',
    'Port': 'Port',
    'Portrait': 'Portrait',
    'Position Your Photo': 'Positionieren Sie Ihr Foto',
    'Preformatted Text': 'vorformatierter Text',
    'Prevent Search Engines From Indexing This Page': 'Halten Sie Suchmaschinen vor dem Indexieren dieser Seite ab.',
    'Prioritize My Request': 'Meine Anfrage priorisieren',
    'Protocol': 'Protokol',
    'Provide a short and descriptive name for the anchor.': 'Stellen Sei einen kurzen und beschreibenden Namen für den Anker zur Verfügung.',
    'Provide as much detail as necessary. For example, how can the problem be replicated? Are you receiving an error message?': 'Stellen Sie so viele Details wie nötig zur Verfügung. Zum Beispiel, wie kann das Problem wiederholt werden? Erhalten Sie Fehlermeldungen?',
    'Publish': 'Veröffentlichen',
    'Published by {name}': 'Veröffentlichen mit {name}',
    'Published Changes': 'Veröffentlichte Änderungen',
    'Publishing {processed} of {total} Pages': 'Veröffentlichen 0 Seiten | Veröffentlichen 1 Seite | Veröffentlichen {processed} von {total} Seiten',
    'Receive an email when others publish changes to this site.': 'Erhalten Sie eine E-Mail, wenn andere Änderungen auf dieser Website veröffentlichen.',
    'Recent Activity': 'kürzliche Aktivität',
    'Recover My Account': 'Mein Konto wiederherstellen',
    'Recover My Password': 'Mein Passwort wiederherstellen',
    'Recovery Code': 'Wiederherstellungscode',
    'Redo': 'wieder herstellen',
    'Referring URLs': 'Bezug nehmende URLs',
    'Refresh': 'neu laden',
    'Regenerate': 'Regenerieren',
    'Region': 'Region',
    'Remember This Device': 'Dieses Gerät merken',
    'Remove Formatting': 'Formatierung löschen',
    'Remove Link': 'Link löschen',
    'Remove': 'Löschen',
    'Rename': 'Umbenennen',
    'Repeat': 'Wiederholen',
    'Require for all users': 'Für alle Benutzer erforderlich',
    'Require Two-factor Authentication': 'Zwei-Faktor-Authentifizierung erforderlich',
    'Reset Demo': 'Demo zurücksetzen',
    'Reset My Password': 'Mein Passwort zurücksetzen',
    'Reset Your Password': 'Setze dein Passwort zurück',
    'Resources': 'Ressourcen',
    'Revoke': 'Wiederrufen',
    'Rotate': 'Drehen',
    'Row': 'Reihe',
    'Save Changes': 'Änderungen speichern',
    'Save Draft & Upgrade': 'Entwurf speichern & aktualisieren',
    'Save Draft': 'Entwurf speichern',
    'Saved a Draft': 'Entwurf gespeichert',
    'Saved by {name}': 'Gespeichert als {name}',
    'Saving...': 'speichern…',
    'Screen Colors': 'Bildschirmfarben',
    'Screen Resolutions': 'Bildschirmauflösung',
    'Search hundreds of thousands of free, high-quality photos.': 'Suchen Sie hunderthausende gratis Fotos in hoher Qualität.',
    'Search Pages': 'Seiten suchen',
    'Search Sites': 'Websites suchen',
    'Search Unsplash': 'Unsplash suchen',
    'Search Users': 'Benutzer suchen',
    'Secret Access Key': 'Geheimer Zugangscode',
    'Section Break': 'Abschnittslücke',
    'Select a logo to use on dark backgrounds.': 'Wählen Sie ein Logo für dunklen Hintergrund.',
    'Select a logo to use on light backgrounds.': 'Wählen Sie ein Logo für hellen Hintergrund.',
    'Select a profile to enable the analytics dashboard for this site.': 'Suchen Sie ein Profil aus, um das Analytik Dashboard auf dieser Seite zu aktivieren.',
    'Select an image to use as the favicon.': 'Wählen Sie en Bild als favicon.',
    'Select the folder that contains your homepage.': 'Wählen Sie die Ordner aus, welche Ihre Hompage beinhalten.',
    'Select the folder where uploaded files will be stored.': 'Wählen Sie den Ordner, wo hochgeladene Dateien gespeichert werden.',
    'Select': 'Auswählen',
    'Selected Pages': 'ausgewählte Seiten',
    'Server Error': 'Server Fehler',
    'Services': 'Dienstleistungen',
    'Settings': 'Einstellungen',
    'Shown in browser tabs and search results.': 'Gezeigt in Browser Tabs und Suchresultaten.',
    'Shown under the title in search results.': 'Gezeigt unter diesem Titel bei Suchresultaten.',
    'Shown when the page is shared in third-party apps.': 'Gezeigt, wenn die Seite mit Drittpartien Apps geteilt wird.',
    'Shown when users hover over the link.': 'Gezeigt, wenn Benutzer über dem Link schweben.',
    'Sites': 'Websites',
    'Size': 'Grösse',
    'Small Print': 'kleiner Druck',
    'Sorry, but the editor could not be initialized. Please reload the page and try again.': 'Sorry, aber der Editor konnte nicht initialisiert werden. Bitte laden Sie die Seite neu und versuchen es noch einmal.',
    'Source': 'Quelle',
    'Split Cells': 'gespaltene Zellen',
    'Squarish': 'Quadratisch',
    'Start Date': 'Start Datum',
    'Start typing to add a site...': 'Starten mit Tippen um eine Website hinzuzufügen…',
    'Strikethrough': 'Durchstreichen',
    'Submit Request': 'Anfrage senden',
    'Submit': 'senden',
    'Subscript': 'Index',
    'Superscript': 'Exponent',
    'Support URL': 'Unterstütungs URL',
    'Support': 'Hilfe',
    'Table': 'Tabelle',
    'Technical': 'Technisch',
    'Template': 'Vorlage',
    'Test Connection': 'Test Verbindung',
    'Thanks for confirming your {appName} account!': 'Vielen Dank für die Bestätigung Ihres Kontos {appName}!',
    'Thanks for using {appName}!': 'Vielen Dank, dass Sie {appName} verwenden!',
    'The analytics dashboard has not been enabled for this site.': 'Das Analytics Dashboard wurde für diese Website nicht aktiviert.',
    'The demo has been reset.': 'Die Demo wurde zurück gesetzt.',
    'The link you followed has expired.': 'Dieser Link ist abgelaufen.',
    'The page will be created inside this folder on your server.': 'Die Seite wird in diesem Ordner auf Ihrem Server erstellt.',
    'The page you requested could not be found.': 'Die angefragte Seite konnte nicht gefunden werden.',
    'The selected path is outside of the site\'s home folder.': 'Die ausgewählte Seite ist ausserhalb des Home Ordners dieser Website.',
    'The token you entered is not valid.': 'Das von Ihnen eingegebene Token ist ungültig.',
    'This adds an extra layer of security to your account by requiring access to a known device (such as a smartphone) before logging into your account.': 'Dies fügt Ihrem Konto eine zusätzliche Sicherheitsebene hinzu, indem Sie Zugriff auf ein bekanntes Gerät (z. B. ein Smartphone) benötigen, bevor Sie sich bei Ihrem Konto anmelden.',
    'This appears to be a commercial website, but you\'re on a personal plan. Please upgrade your account to publish this website.': 'Dies scheint eine kommerzielle Website zu sein, aber Sie benutzen einen persönlichen Plan. Bitte aktualisieren Sie ihren Account, um diese Website zu veröffentlichen.',
    'This cannot be changed when you\'re logged in to your custom domain.': 'Dies kann nicht geändert werden, wenn Sie in ihrer kundenspezifischen Domain angemeldet sind.',
    'This domain is already in use.': 'Diese Domain ist bereits in Gebrauch.',
    'This domain is no longer active.': 'Diese Domain ist nicht mehr aktiv.',
    'This email address is already in use.': 'Diese E-mail Adresse wird bereits verwendet.',
    'This email address is not registered.': 'Diese E-mail Adresse ist nicht registriert.',
    'This information will appear on all of your invoices.': 'Diese Information wird in all Ihren Rechnungen erscheinen.',
    'This is used to reference the page in the CMS.': 'Damit wird auf ihre Seite im CMS verwiesen.',
    'This is where you and your clients will go to access the CMS.': 'Hier werden Sie und Ihre Kunden Zugriff auf das CMS haben.',
    'This is your API token. Protect it like you would a password. If your token is ever compromised, you can regenerate it using the button above.': 'Dies ist Ihr API-Token. Schützen Sie es wie ein Passwort. Wenn Ihr Token jemals kompromittiert wird, können Sie es mit der obigen Schaltfläche neu generieren.',
    'This page doesn\'t have any content regions.': 'Diese Seite hat keine Inhaltsregionen.',
    'This request cannot be completed because the site is on lockdown.': 'Ihre Anfrage kann nicht beendet werden, weil diese Seite abgeschaltet ist.',
    'This site has reached the maximum number of templates allowed.': 'Diese Seite hat das Maximum an erlaubten Vorlagen erreicht.',
    'This Site is on Lockdown': 'Diese Website ist on Lockdown',
    'This type of file is not supported.': 'Dieser Dateityp wird nicht unterstützt.',
    'This user is an administrator so they have access to all sites. You need to disable administrative privileges if you want to limit their access.': 'Dieser Benutzer ist ein Admin, er hat Zugriff auf alle Websites. Sie müssen die administrativen Privilegien deaktivieren, wenn Sie deren Zugriff limitieren wollen.',
    'This user will have access to the following sites.': 'Dieser Benutzer hat Zugriff zu folgenden Websites.',
    'This will be displayed instead of "Surreal CMS" throughout the app.': 'Das wird in der ganzen App anstatt von “Surreal CMS” angezeigt.',
    'This will be shown in search engine results, browser tabs, bookmarks, etc.': 'Das wird angezeigt in Suchmaschinen Resultaten, Browser-Fenstern, Bookmarks, etc.',
    'This will cause existing links to this file to stop working.': 'Das wird dafür sorgen, dass existierende Links zu dieser Datei nicht mehr funktionieren.',
    'This will delete the site from the CMS, but not from your web server.': 'Website aus dem CMS entfernen, aber nicht auf dem Webserver löschen.',
    'This will delete the user and revoke all access to the CMS.': 'Löschen des Benutzers und verwerfen des Zuganges zum CMS.',
    'This will delete your account permanently.': 'Den Account endgültig löschen.',
    'This will destroy your token and disable API access. All applications that use this token will stop working.': 'Dadurch wird Ihr Token zerstört und der API-Zugriff deaktiviert. Alle Anwendungen, die dieses Token verwenden, funktionieren nicht mehr.',
    'This will permanently delete the selected blocks.': 'Endgültiges Löschen der ausgewählten Blöcke .',
    'This will permanently delete the selected pages from your web server.': 'Endgültiges Löschen der ausgewählten Seiten von Ihrem Webserver.',
    'This will permanently delete the selected templates.': 'Endgültiges Löschen der ausgewählten Vorlagen.',
    'This will remove the selected pages from the CMS, but not from your web server.': 'Ausgewählten Seiten aus dem CMS entfernen, aber nicht auf dem Webserver löschen.',
    'This will require all users to enable two-factor authentication. Every user will need to use an app such as Google Authenticator before they can access their account.': 'Dies erfordert, dass alle Benutzer die Zwei-Faktor-Authentifizierung aktivieren. Jeder Nutzer muss eine App wie Google Authenticator verwenden, bevor er auf sein Konto zugreifen kann.',
    'Tile': 'Platte',
    'Title': 'Titel',
    'To change your subscription, please visit the {billing} section.': 'Um ihre Abonnement zu ändern gehen Sie bitte zu {billing}.',
    'To enable two-factor authentication for just your account, visit the profile page.': 'Besuchen Sie die Profilseite, um die Zwei-Faktor-Authentifizierung nur für Ihr Konto zu aktivieren.',
    'to': 'zu',
    'Today': 'Heute',
    'Toggle Full Screen Mode': 'Umschalten in Vollbild Modus',
    'Toggle Header Cells': 'Umschalten zu Kopfzeilen',
    'Traffic Sources': 'Traffic Sources',
    'Traffic': 'Traffic',
    'Two-factor Authentication': 'Two-factor Authentication',
    'Type a few sentences about this user.': 'Schreiben Sie ein paar Sätze über diesen Benutzer.',
    'Type a few sentences about yourself.': 'Schreiben Sie ein paar Sätze über sich selbst.',
    'Type of Website': 'Art der Website',
    'Unable to authenticate with your server.': 'Ihr Server kann nicht authentifiziert werden.',
    'Unable to connect to your website.': 'Die Verbindung zu Ihrer Website ist nicht möglich.',
    'Unable to create the directory on your server.': 'Das Verzeichnis kann auf Ihrem Server nicht erstellt werden.',
    'Unable to delete the file from your server.': 'Diese Datei kann nicht von Ihrem Server gelöscht werden.',
    'Unable to download the file from your server.': 'Diese Datei kann nicht von Ihrem Server herunter geladen werden.',
    'Unable to list the directory on your server.': 'Das Verzeichnis auf Ihrem Server kann nicht angezeigt werden.',
    'Unable to move the file on your server.': 'Die Datei kann auf Ihrem Server nicht verschoben werden.',
    'Unable to upload the file to your server.': 'Die Datei kann nicht auf Ihren Server hochgeladen werden.',
    'Undo': 'rückgängig machen',
    'Unsaved Changes': 'Nichtgespeicherte Änderungen',
    'Unsupported Element': 'Nicht unterstütztes Element',
    'Update Anchor': 'Anker aktualisieren',
    'Update Background': 'Hintergrund aktualisieren',
    'Update Code Block': 'Code Block aktualisieren',
    'Update Gallery': 'Galerie aktualisieren',
    'Update Image': 'Bild aktualisieren',
    'Update Link': 'Link aktualisieren',
    'Update Metadata': 'Metadaten aktualisieren',
    'Update Payment Info': 'Zahlungsinformationen aktualisieren',
    'Update Video': 'Video aktualisieren',
    'Upgrade My Account': 'Meinen Account upgraden',
    'Upgrade Required': 'Upgrade nötig',
    'Upgrade to unlock priority support, commercial sites, and more features!': 'Upgraden, um bevorzugten Support, kommerzielle Websites und mehr Eigenschaften frei zu schalten!',
    'Upgrade': 'Upgrade',
    'Upload Folder': 'Ordner hochladen',
    'Upload': 'hochladen',
    'Uploads': 'Hochgeladene',
    'URL': 'URL',
    'Username': 'Benutzername',
    'Users': 'Benutzer',
    'Video': 'Video',
    'View Info': 'Info ansehen',
    'View Invoice': 'Rechnungen ansehen',
    'View on Unsplash': 'Unsplash ansehen',
    'View Webpage': 'Webpage ansehen',
    'View Website': 'Website ansehen',
    'Visit Documentation': 'Dokumentation anzeigen',
    'Visitors': 'Besucher',
    'Visits': 'Besuche',
    'Warning': 'Warnung',
    'We can save your changes as a draft so you can publish them after you\'ve upgraded.': 'Änderungen als Entwurf speichern, damit man sie nach dem Upgrade veröffentlichen kann.',
    'We hope you enjoy using {appName}': 'Wir wünschen Ihnen viel Spaß bei der Verwendung von {appName}',
    'We provide a demo site for you to experiment with. If you\'ve modified it or removed it, you can reset it here.': 'Wir stellen für Sie eine Demoseite zum Experimentieren zur Verfügung. Wenn Sie diese modifiziert oder gelöscht haben, können Sie sie hier wieder zurücksetzen.',
    'We were unable to fetch data from your analytics provider.': 'Wir konnten die Daten von Ihrem Analytics Anbieter nicht abrufen.',
    'Website Classification Guidelines': 'Richtlinien zur Website-Klassifizierung',
    'Welcome to {appName}': 'Willkommen bei {appName}',
    'Welcome!': 'Willkommen!',
    'What do you need help with?': 'Womit brauchen Sie Hilfe?',
    'When enabled, users won\'t be able to publish changes to the site.': 'Wenn nicht freigeschalten, können Benutzer keine Änderungen auf dieser Website veröffentlichen.',
    'Which site does this involve?': 'Welche Website ist betroffen?',
    'White-label settings will be applied when you login in to your custom domain.': 'White-label Einstellungen werden angewendet, wenn Sie sich an Ihrer custom domain anmelden.',
    'White-label Settings': 'White-label Einstellungen',
    'Yesterday': 'Gestern',
    'You must enable two-factor authentication for your own account before requiring it for everyone.': 'Sie müssen die Zwei-Faktor-Authentifizierung für Ihr eigenes Konto aktivieren, bevor Sie sie für alle Benutzer benötigen.',
    'You recently requested to reset the password for your {appName} account.': 'Sie haben kürzlich angefordert, Ihr Passwort für Ihr {appName}-Konto zurückzusetzen.',
    'Your administrator requires two-factor authentication for all accounts.': 'Ihr Administrator benötigt für alle Konten eine Zwei-Faktor-Authentifizierung.',
    'Your analytics provider says you do not have permission to access this property.': 'Ihr Analytic Anbieter sagt, Sie haben keinen Zugriff auf diese Property.',
    'Your changes have been saved.': 'Ihre Änderungen wurden gespeichert.',
    'Your changes haven\'t been saved. Are you sure you want to continue?': 'Ihre Änderungen wurden nicht gespeichert. Wollen Sie trotzdem fortfahren?',
    'Your favorites will appear in the sidebar for quick access.': 'Ihre Favoriten werden für schnellen Zugriff in der Seitenleiste angezeigt.',
    'Your password has been updated.': 'Ihr Passwort wurde aktualisiert.',
    'Your password is incorrect.': 'Ihr Passwort ist nicht korrekt.',
    'Your request has been received. We\'ll be in touch soon!': 'Wir haben Ihre Anfrage erhalten. Wir melden uns bald!',
    'Your syntax highlighter will use this to identify the programming language.': 'Ihr syntax highlighter wird dies für die Identifikation ihrer Programmiersprache benützen.',
    'Zoom': 'Zoom',

    // Import the corresponding Element UI locale
    ...elementLocale
  },

  // Date formats
  dateTimeFormats: {
    'short': {
      'year': 'numeric',
      'month': 'short',
      'day': 'numeric'
    },
    'medium': {
      'year': 'numeric',
      'month': 'short',
      'day': 'numeric',
      'hour': 'numeric',
      'minute': 'numeric'
    },
    'long': {
      'year': 'numeric',
      'month': 'short',
      'day': 'numeric',
      'weekday': 'short',
      'hour': 'numeric',
      'minute': 'numeric'
    }
  },

  // Number formats
  numberFormats: {
    'currency': {
      'style': 'currency',
      'currency': 'EUR'
    },
    'currencyInteger': {
      'style': 'currency',
      'currency': 'EUR',
      'minimumFractionDigits': 0,
      'maximumFractionDigits': 0
    },
    'decimal': {
      'style': 'decimal',
      'useGrouping': true
    },
    'integer': {
      'style': 'decimal',
      'useGrouping': true,
      'maximumFractionDigits': 0
    }
  }
};
